<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Noty'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <div class="invoice-document-details-view-container" *ngIf="invoiceDocumentObject" fxLayout="column"
         fxLayoutGap="15px">
      <div fxLayout="row" fxLayoutGap="15px">
        <button
          [disabled]="!(userPermissions | async)?.settlement?.read"
          (click)="downloadPdf()"
          mat-stroked-button
        >
          <mat-icon>download</mat-icon>
          <span> PDF</span></button>
        <button
          *ngIf="(userPermissions | async)?.settlement?.create"
          (click)="delete()" mat-stroked-button color="warn"
        >
          <mat-icon>delete</mat-icon>
          <span> Usuń</span></button>
      </div>
      <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
        <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane noty: {{invoiceDocumentObject?.number }}</h3>
            </div>

            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Kwota">
                {{ (invoiceDocumentObject?.net ?? 0) | number:'1.2-2' }} zł
              </app-detail>

              <app-detail fxFlex="50" header="Pozostało">
                {{ (invoiceDocumentObject?.remainingAmount ?? 0) | number:'1.2-2' }} zł
              </app-detail>
            </div>

            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="15px">
              <app-detail fxFlex="50" header="Data wystawienia">
                {{ invoiceDocumentObject?.issueDate | date:'dd.MM.yyyy' }}
              </app-detail>

              <app-detail fxFlex="50" header="Powód wystawienia">
                {{ invoiceDocumentObject?.reason || '-' }}
              </app-detail>
            </div>
          </mat-card>
        </div>
        <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
          <mat-card>
            <div fxLayout="row">
              <h3>Relacje</h3>
            </div>
            <div fxLayout="row">
              <app-detail fxFlex="100" header="Umowa"
                          [value]="invoiceDocumentObject?.contract?.type.name + ' (nr: ' + invoiceDocumentObject?.contract?.number + '), zawarta ' + (invoiceDocumentObject?.contract?.concludeDate | date:'y-MM-dd')"
                          [link]="invoiceDocumentObject?.contract ? ['/umowy/szczegoly', invoiceDocumentObject?.contract?.uuid] : undefined">
              </app-detail>
            </div>

            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="15px">

              <app-detail fxFlex="50" header="Partner"
                          [value]="invoiceDocumentObject?.partner?.shortName"
                          [link]="['/partnerzy/szczegoly', invoiceDocumentObject?.partner?.uuid]">
              </app-detail>


              <app-detail fxFlex="50" header="Firma">
                {{ invoiceDocumentObject?.company?.name }}
              </app-detail>
            </div>
          </mat-card>
        </div>
      </div>
      <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
        <mat-card fxFlex="100">
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <h3>Dokumenty księgowe</h3>
          </div>

          <table mat-table [dataSource]="invoiceDocumentObject?.deductions || []">

            <ng-container matColumnDef="number">
              <th mat-header-cell *matHeaderCellDef>Numer faktury</th>
              <td mat-cell *matCellDef="let row">
                <a class="default-link" [routerLink]="['/faktury/szczegoly', row.invoice?.uuid]">
                  {{ row.invoice?.number || '-' }}
                </a>
              </td>
            </ng-container>

            <ng-container matColumnDef="issueDate">
              <th mat-header-cell *matHeaderCellDef>Data wystawienia faktury</th>
              <td mat-cell *matCellDef="let row">
                {{ row.invoice?.issueDate | date:'dd.MM.yyyy' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>Status faktury</th>
              <td mat-cell *matCellDef="let row">
                {{ row.invoice?.status?.name || '-' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="net">
              <th mat-header-cell *matHeaderCellDef>Kwota faktury</th>
              <td mat-cell *matCellDef="let row">
                {{ (row.invoice?.net ?? 0) | number:'1.2-2' }} zł
              </td>
            </ng-container>

            <ng-container matColumnDef="amount">
              <th mat-header-cell *matHeaderCellDef>Potrącono</th>
              <td mat-cell *matCellDef="let row">
                {{ (row.amount ?? 0) | number:'1.2-2' }} zł
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let row">
                <button mat-icon-button color="accent" aria-label="" (click)="downloadDeductionPdf(row?.uuid)">
                  <mat-icon>download</mat-icon>
                </button>
              </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="deductionDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: deductionDisplayedColumns;"></tr>
          </table>

          <div *ngIf="!invoiceDocumentObject?.deductions?.length" class="empty-table">
            Brak dowiązanych dokumentów księgowych.
          </div>
        </mat-card>
      </div>
    </div>
  </mat-tab>
<!--  <mat-tab label="Historia zmian">-->
<!--    <ng-template matTabContent>-->
<!--      <app-log-list [invoiceDocument]="invoiceDocument"></app-log-list>-->
<!--    </ng-template>-->
<!--  </mat-tab>-->
</mat-tab-group>
